var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"home"}},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"icon-material":"menu","panel-open":"left"}})],1),_vm._v(" "),_c('f7-nav-title',{attrs:{"sliding":""}},[_vm._v("maskCount")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }